// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"90b2827d","455":"70ba9b3c","977":"3714c425"}[chunkId] + ".chunk.js";
};